import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds", "status", "summary", "badge", "label", "time"]
  static values = { date: String, startsAt: String, endsAt: String }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    const now = new Date()
    const target = this.targetDate(now)
    if (!target) return

    const diff = target - now

    if (diff <= 0) {
      this.writeTime(0, 0, 0, 0)
      clearInterval(this.timer)
      return
    }

    const days    = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    this.writeTime(days, hours, minutes, seconds)
  }

  targetDate(now) {
    if (this.hasStartsAtValue && this.hasEndsAtValue) {
      const startsAt = new Date(this.startsAtValue)
      const endsAt = new Date(this.endsAtValue)

      if (now < startsAt) {
        this.writeBadge("30개사 한정")
        this.writeLabel("Klavy 1차 파트너 에이전시 오픈 · 5/19", "Klavy 1차 파트너 오픈")
        this.writeStatus("오픈까지")
        this.showTime()
        return startsAt
      }

      if (now <= endsAt) {
        this.writeBadge("30개사 한정")
        this.writeLabel("Klavy 1차 파트너 에이전시 모집 · 5/19-27", "Klavy 1차 파트너 모집")
        this.writeStatus("마감까지")
        this.showTime()
        return endsAt
      }

      this.writeBadge("1차 마감")
      this.writeLabel("Klavy 1차 파트너 에이전시 모집 5/19-27 종료", "Klavy 1차 파트너 모집 종료")
      this.writeStatus("2차는 대기자 우선 안내")
      this.hideTime()
      clearInterval(this.timer)
      return null
    }

    return new Date(this.dateValue + "T00:00:00+09:00")
  }

  writeStatus(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }

  writeBadge(text) {
    if (this.hasBadgeTarget) this.badgeTarget.textContent = text
  }

  writeLabel(text, mobileText = text) {
    if (!this.hasLabelTarget) return

    const isMobile = window.matchMedia("(max-width: 720px)").matches
    this.labelTarget.textContent = isMobile ? mobileText : text
  }

  showTime() {
    if (this.hasTimeTarget) this.timeTarget.hidden = false
  }

  hideTime() {
    if (this.hasTimeTarget) this.timeTarget.hidden = true
  }

  writeTime(days, hours, minutes, seconds) {
    if (this.hasSummaryTarget) {
      const isMobile = window.matchMedia("(max-width: 720px)").matches
      this.summaryTarget.textContent = isMobile
        ? `${days}일 ${hours}시간 ${minutes}분 남음`
        : `${days}일 ${hours}시간 ${minutes}분 ${seconds}초 남음`
    }
    if (this.hasDaysTarget) this.daysTarget.textContent = String(days).padStart(2, "0")
    if (this.hasHoursTarget) this.hoursTarget.textContent = String(hours).padStart(2, "0")
    if (this.hasMinutesTarget) this.minutesTarget.textContent = String(minutes).padStart(2, "0")
    if (this.hasSecondsTarget) this.secondsTarget.textContent = String(seconds).padStart(2, "0")
  }
}
